import { EmailModal } from '@/components/ui/EmailModal/EmailModal';
import { Info } from 'lucide-react';
import Link from 'next/link';

export const PlayerInfo = () => {
  return (
    <div className="flex relative z-30">
      <EmailModal
        tracking={{
          event: 'tone.player_info_modal.opened',
        }}
        pill="Beta"
        trigger={<Info size={20} className="ml-1 mr-0 lg:ml-3 lg:mr-2" />}
        message={
          <span className="text-zinc-400">
            Preview NAM captures and IR's directly in your browser.
            <br />
            <br />
            <b>Demo Mode</b>: Audition tones using DI recordings submitted by the TONE3000 community.
            <br />
            <br />
            <Link
              className="text-[#40A6FF] underline"
              target="_blank"
              rel="noopener noreferrer"
              href={'/blog/introducing-the-nam-web-player'}
            >
              Introducing the NAM Web Player
            </Link>
            <br />
            <br />
            <b>Play Mode</b>: Connect your instrument via an audio interface to play through tones directly on the website.
            <br />
            <br />
            <Link
              className="text-[#40A6FF] underline"
              target="_blank"
              rel="noopener noreferrer"
              href={'/blog/introducing-live-input-on-tone3000'}
            >
              Introducing Live Input on TONE3000
            </Link>
            <br />
            <br />
            Note: The preview player only supports A2-Lite models.
          </span>
        }
        title="Preview Player"
        emailMessage="Questions? Email us:"
        closeButton={false}
      />
    </div>
  );
};
